var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tiktok_black",
    "data-name": "tiktok black",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.26,
    height: 18.524,
    viewBox: "0 0 16.26 18.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok_black-2",
    "data-name": "tiktok black",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10435",
    "data-name": "Group 10435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27755",
    "data-name": "Path 27755",
    d: "M8.574,0c0,.167,0,.3,0,.439q0,6.02-.006,12.04c0,.19-.006.38-.024.569a2.743,2.743,0,0,1-5.452.058,2.69,2.69,0,0,1,2.066-2.961,7.419,7.419,0,0,1,1.505-.016v-3.1a17.1,17.1,0,0,0-1.91.127A5.716,5.716,0,0,0,.123,13.924,5.811,5.811,0,0,0,7.2,18.35a5.75,5.75,0,0,0,4.422-5.661c0-2.081-.013-4.161-.021-6.242,0-.112,0-.224,0-.4A7.689,7.689,0,0,0,16.26,7.623V4.63a4.729,4.729,0,0,1-3.272-1.364A4.7,4.7,0,0,1,11.586,0Z",
    transform: "translate(0)",
    fill: "#fcbf49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokBlack);
export default __webpack_public_path__ + "static/media/tiktok-black.5a62f0383c5b54bb4d3aec5d19c5483a.svg";
export { ForwardRef as ReactComponent };